import { FaFilm } from 'react-icons/fa'
import { IconType } from 'react-icons'
import { SidebarItem } from './menuItems'

const demoVideosButton: SidebarItem = {
  title: 'Demo Videos',
  to: '/demos',
  icon: FaFilm as IconType,
}

export default demoVideosButton
